/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_DescriptionInputs */

const id_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik tentang platform`)
};

const ms_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik tentang platform`)
};

const da_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik om platformen`)
};

const de_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiken über die Plattform`)
};

const en_us2_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics about the platform`)
};

const es_es2_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas sobre la plataforma`)
};

const es_mx2_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas sobre la plataforma`)
};

const fil_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadistika tungkol sa platform`)
};

const fr_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques sur la plateforme`)
};

const it_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche sulla piattaforma`)
};

const hu_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statisztikák a platformról`)
};

const nl_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistieken over het platform`)
};

const no_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistikk om plattformen`)
};

const pl_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki platformy`)
};

const pt_br2_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics`)
};

const pt_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas sobre a plataforma`)
};

const ro_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistici despre platformă`)
};

const fi_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilastoja alustasta`)
};

const sv_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik om plattformen`)
};

const vi_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê về nền tảng`)
};

const tr_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform hakkında istatistikler`)
};

const cs_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiky o platformě`)
};

const bg_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика за платформата`)
};

const ru_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика о платформе`)
};

const uk_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика про платформу`)
};

const ar_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصائيات حول المنصة`)
};

const hi_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेटफ़ॉर्म के बारे में आँकड़े`)
};

const th_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติเกี่ยวกับแพลตฟอร์ม`)
};

const ja_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォームに関する統計`)
};

const zh_cn2_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics`)
};

const zh_hant1_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics`)
};

const ko_components_stats_description = /** @type {(inputs: Components_Stats_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics`)
};

/**
* | output |
* | --- |
* | "Statistics about the platform" |
*
* @param {Components_Stats_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_description = /** @type {((inputs?: Components_Stats_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_description(inputs)
	if (locale === "ms") return ms_components_stats_description(inputs)
	if (locale === "da") return da_components_stats_description(inputs)
	if (locale === "de") return de_components_stats_description(inputs)
	if (locale === "en-US") return en_us2_components_stats_description(inputs)
	if (locale === "es-ES") return es_es2_components_stats_description(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_description(inputs)
	if (locale === "fil") return fil_components_stats_description(inputs)
	if (locale === "fr") return fr_components_stats_description(inputs)
	if (locale === "it") return it_components_stats_description(inputs)
	if (locale === "hu") return hu_components_stats_description(inputs)
	if (locale === "nl") return nl_components_stats_description(inputs)
	if (locale === "no") return no_components_stats_description(inputs)
	if (locale === "pl") return pl_components_stats_description(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_description(inputs)
	if (locale === "pt") return pt_components_stats_description(inputs)
	if (locale === "ro") return ro_components_stats_description(inputs)
	if (locale === "fi") return fi_components_stats_description(inputs)
	if (locale === "sv") return sv_components_stats_description(inputs)
	if (locale === "vi") return vi_components_stats_description(inputs)
	if (locale === "tr") return tr_components_stats_description(inputs)
	if (locale === "cs") return cs_components_stats_description(inputs)
	if (locale === "bg") return bg_components_stats_description(inputs)
	if (locale === "ru") return ru_components_stats_description(inputs)
	if (locale === "uk") return uk_components_stats_description(inputs)
	if (locale === "ar") return ar_components_stats_description(inputs)
	if (locale === "hi") return hi_components_stats_description(inputs)
	if (locale === "th") return th_components_stats_description(inputs)
	if (locale === "ja") return ja_components_stats_description(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_description(inputs)
	return ko_components_stats_description(inputs)
});
export { components_stats_description as "components.stats.description" }